import { Button, LoadingOverlay } from '@mantine/core';
import { useEffect, useState } from 'react';

import { Declaration } from '@e-origin/shared';

import { HideElementFor, LeavePageNotification, StickyContainer } from '@components';
import { useDeclarant } from '@hooks/declarant';
import { CustomsSection } from './CustomsSection';
import { GlobalAndProcedureSection } from './GlobalAndProcedureSection';
import { TransportAndPackagingSection } from './TransportAndPackagingSection';
import { useDeclarationGeneralForm } from './useDeclarationGeneralInfoForm';

interface DeclarationViewGeneralInfoProps {
  declaration: Declaration;
  editDisabled?: boolean;
}

export const DeclarationViewGeneralInfo: React.FC<DeclarationViewGeneralInfoProps> = ({ declaration, editDisabled }) => {
  const { form, isExport, declarationTypeDisabled, onSubmit, isSaving, buildFormValues } = useDeclarationGeneralForm({ declaration, editDisabled });
  const { data: declarant, isLoading } = useDeclarant();
  const [declarationGroup, setDeclarationGroup] = useState<string>(declaration?.generalInfo?.group);

  if (!declarant) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  useEffect(() => {
    form.setValues(buildFormValues(declaration));
    form.resetDirty({});
    setDeclarationGroup(declaration?.generalInfo?.group);
  }, [declaration]);

  return (
    <>
      <LeavePageNotification hasUnsavedChanges={form.isDirty()} />

      <form onSubmit={form.onSubmit(onSubmit)} style={{ paddingRight: '30%' }}>
        <GlobalAndProcedureSection
          form={form}
          editDisabled={editDisabled}
          isExport={isExport}
          declarationTypeDisabled={declarationTypeDisabled}
          declaration={declaration}
          declarationGroup={declarationGroup}
          onSave={(newGroup) => onSubmit({ ...form.values, generalInfo: { ...form.values.generalInfo, group: newGroup } })}
        />

        <CustomsSection form={form} declarant={declarant} editDisabled={editDisabled} declarationGroup={declarationGroup} isExport={isExport} />

        <HideElementFor systems={['DECO', 'IDMS_LV']} declarationGroup={declarationGroup}>
          <TransportAndPackagingSection form={form} declarant={declarant} editDisabled={editDisabled} isExport={isExport} declarationGroup={declarationGroup} />
        </HideElementFor>

        <StickyContainer noPl>
          <Button
            data-pw="submit-btn"
            type="submit"
            key="save-modal-btn"
            disabled={editDisabled || !form.isValid()}
            loading={isSaving}
            variant="filled"
            size="lg"
          >
            Save
          </Button>
        </StickyContainer>
      </form>
    </>
  );
};
